import { useStore } from "../../stores/store";
import { priorityMeta } from "../../lib/utils";

export function StatsBar() {
  const cards = useStore((s) => s.cards);

  const counts = { low: 0, medium: 0, high: 0, urgent: 0 } as Record<string, number>;
  for (const c of cards) counts[c.priority] = (counts[c.priority] || 0) + 1;

  return (
    <div className="flex items-center gap-3 md:gap-5 border-b border-white/5 bg-black/25 px-3 md:px-5 py-2 text-[11px] text-slate-400 overflow-x-auto scrollbar-thin">
      <div className="flex items-center gap-2 md:gap-3">
        {(["urgent", "high", "medium", "low"] as const).map((p) => (
          <span key={p} className={`inline-flex items-center gap-1.5 ${priorityMeta[p].color}`} title={priorityMeta[p].label}>
            <span className="h-1.5 w-1.5 rounded-full bg-current shadow-[0_0_8px_currentColor]" />
            <span className="hidden md:inline text-[10px] uppercase tracking-wider text-slate-500">{priorityMeta[p].label}</span>
            <span className="font-mono text-slate-200">{counts[p] || 0}</span>
          </span>
        ))}
      </div>

      <div className="ml-auto hidden md:flex items-center gap-2 font-mono text-[10px] text-slate-500">
        <Kbd>⌘N</Kbd>
        <span className="text-[10px]">nova</span>
        <Kbd>⌘K</Kbd>
        <span className="text-[10px]">buscar</span>
        <Kbd>⌘/</Kbd>
        <span className="text-[10px]">chat</span>
        <Kbd>Esc</Kbd>
        <span className="text-[10px]">fechar</span>
      </div>
    </div>
  );
}

function Kbd({ children }: { children: React.ReactNode }) {
  return (
    <kbd className="rounded bg-white/5 px-1.5 py-0.5 text-slate-300 ring-1 ring-white/5">{children}</kbd>
  );
}
